export default __webpack_public_path__ + "static/media/pencil_icon.e7fd248c.svg";